import { Rule } from '../types/rule'

export const pipelineRules: Rule[] = [
  {
    id: 'awc-3-days',
    name: 'AWC Longer than 3 days',
    severity: 'critical',
    check: (loan, section) => section === 'AWC' && loan.amount > 200000, // Mock logic: AWC loans over 200k are "old" for demo
    description: 'Loans stuck in AWC stage for more than 72 hours',
  },
  {
    id: 'payoff-expiring',
    name: 'Payoff Expiring Within 7 Days',
    severity: 'warning',
    check: (loan) =>
      !!loan.payoffExpDate &&
      (loan.payoffExpDate.includes('Jan') ||
        loan.payoffExpDate.includes('Dec')), // Mock logic
    description: 'Payoff statements expiring soon',
  },
  {
    id: 'missing-hoi',
    name: 'Missing HOI Documentation',
    severity: 'warning',
    check: (loan) => !loan.hoiReqStatus || loan.hoiReqStatus === 'Req',
    description: 'Homeowners insurance not yet received',
  },
  {
    id: 'urgent-loans',
    name: 'Urgent Status Loans',
    severity: 'critical',
    check: (loan) => !!loan.isUrgent,
    description: 'Loans marked as urgent priority',
  },
]
